import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import Creator from './Creator';
import ButtonAction from './ButtonAction';
import EntityForm from './EntityForm';
import Collapsible from 'react-collapsible';
import ReactCSSTransition from 'react-transition-group/CSSTransition';
import { CREATOR_TYPES, CREATOR_FIELDS } from '../constants/Fixtures';

export default class CreatorList extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      formIndex: 1,
      creatorForm: this.isEditingInitially(),
    };
  }

  isEditingInitially = () => {
    if (this.context && this.context.editingFields) {
      // context is inherited from Project Maker component to toggle open
      // 'code' field for editing
      return this.context.editingFields.includes('creators');
    } else {
      return false;
    }
  }

  getCreators() {
    return this.props.creators || [];
  }

  toggleAddCreatorForm = () => {
    this.setState({
      creatorForm: !this.state.creatorForm,
      formIndex: this.state.formIndex + 1,
    });
  }

  addCreator = (attributes) => {
    // supply a default for category
    if (attributes.category === undefined) {
      attributes.category = 'author';
    }
    this.props.create(attributes);
    this.toggleAddCreatorForm();
  }

  creationFormText() {
    if (this.props.title) {
      return 'Add ' + this.props.title.replace(/s$/, '');
    } else {
      return 'Add Creator';
    }
  }

  render() {
    return (<div className="section-list" id='creators-list'>
      <Collapsible
        open={this.state.creatorForm}
        trigger={
          <div
            className="section-header"
            onClick={this.toggleAddCreatorForm}
          >
            <h2>{this.props.title || 'Creators'}</h2>
            <ButtonAction
              color='secondary'
              action={this.toggleAddCreatorForm}
              size="sm"
              className='float-md-end'
              icon={this.state.creatorForm ? 'fa-arrow-circle-up' : 'fa-arrow-circle-down'}
            >
              {this.creationFormText()}
            </ButtonAction>
          </div>
        }
      >
        <div >
        </div>
        </Collapsible>
      <Table className="section-table" responsive hover>
        <thead>
          <tr>
            <th>Type</th>
            <th>First</th>
            <th>Middle</th>
            <th>Last</th>
            <th>Suffix</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <ReactCSSTransition
          classNames="list-fold"
          timeout={{ enter: 500, exit: 500 }}>
          <tbody>
            { this.state.creatorForm ? 
              <EntityForm
                key={`${this.props.title || 'creator'}-form-${this.state.formIndex}`}
                fields={CREATOR_FIELDS}
                action={this.addCreator}
                className="section-new-form"
              />
              :
              null
            }
            {this.getCreators().map((cr, index) =>
                (<Creator
                  key={`cr-${cr.id}`}
                  id={cr.id}
                  type={cr.category}
                  first_name={cr.first_name}
                  middle_name={cr.middle_name}
                  last_name={cr.last_name}
                  suffix={cr.suffix}
                  destroy={this.props.destroy}
                  update={this.props.update}
                />),
            )}
          </tbody>
        </ReactCSSTransition>
      </Table>
    </div>);
  }
}

CreatorList.contextTypes = {
  editingFields: PropTypes.array,
}
